
window.promisify = function (fn, receiver) {
    return (...args) => {
      return new Promise(function (resolve, reject) {
        fn.apply(receiver, [
          ...args,
          res => {
            return resolve(res);
          },
          error => {
            return reject(error);
          }
        ]);
      });
    };
  };
  
  export async function getCertId(that) {
    let promiseFunc = window.promisify(window.initXA, window);
  
    let result = await promiseFunc().catch(msg => "error");
    if ("error" === result) {
      that.$message.error("未检测到ukey");
      return null;
    }
  
    promiseFunc = window.promisify(window.SOF_GetUserList, window);
    result = await promiseFunc().catch(msg => "error");
    if (!result || !result.retVal || "error" === result) {
      that.$message.error("获取证书失败");
      return null;
    }
    result = result.retVal.split("&&&").filter(item => !!item);
  
    if (!result || result.length == 0) {
      that.$message.error("请插入带有合法证书的UKEY");
      return null;
    }
  
    result = result[0].split("||")
    const userCode = result[0]
    result = result[1];
    return result
  }
  
  export async function signHashData(certId, hashData) {
    let promiseFunc = window.promisify(window.SOF_SignMessage, window);
    let result = await promiseFunc(0,certId, hashData).catch(msg => console.log(msg));
    return result.retVal
  }
  
  
  export async function isLogin(certId) {
    let result = certId;
    if (!result) {
      return false
    }
    let promiseFunc = window.promisify(window.SOF_SignHashData, window);
    result = await promiseFunc(certId, "j0iWgheBt1MUK3ADkN0TamOqk/vZ0YePA+p80jhMKOQ=", 0x00000004).catch(msg => ({retVal:''}));
    return !!result.retVal
  }
  export async function loginAuth(certId, that) {
    let result = certId;//await getCertId(that)
    if (!result) {
      return false
    }
    const { value } = await that.$prompt("请输入密码", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "password"
    }).catch(msg => ({ value: null }));
    //登陆认证
  
    if (!value) {
      return false;
    }
    let promiseFunc = window.promisify(window.SOF_Login, window);
  
    result = await promiseFunc(result, value).catch(msg => "error");
  
    if ("error" === result) {
      that.$message.error("证书认证失败，请确保证书合法！");
      return false;
    }
    result = result.retVal;
    if (result === true) {
      return true;
    } else {
      that.$message.error("证书认证失败，密码错误！");
      return false;
    }
  }
  
  export async function processSign(data, that) {
    const certId = await getCertId(that)
    if (!certId) {
        return null
    }
  
    //判断登陆是否有效
    let result = await isLogin(certId)
    if (!result) {
        result = await loginAuth(certId, that).catch(msg => console.log(msg))
    }
  
    if (!result) {
        return null
    }
    result = await signHashData(certId,data)
    return result
  }


// WEBPACK FOOTER //
// ./src/js/bjcalib.js